import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.number.is-safe-integer";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.map";
import "core-js/modules/es6.set";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.weak-set";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.math.trunc";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.is-finite";

import "classlist-polyfill";
import "proxy-polyfill";
import "custom-event-polyfill";
import "url-polyfill";
import "nodelist-foreach-polyfill";
import "whatwg-fetch";

if (!("outerHTML" in SVGElement.prototype)) {
  Object.defineProperty(SVGElement.prototype, "outerHTML", {
    get() {
      const temp = document.createElement("div");
      const node = this.cloneNode(true);

      temp.appendChild(node);

      return temp.innerHTML;
    },
    enumerable: false,
    configurable: true
  });
}

SVGAElement.prototype.focus || (SVGAElement.prototype.focus = HTMLElement.prototype.focus);

Element.prototype.matches ||
  (Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

Element.prototype.closest = function closest(css) {
  let node = this;

  while (node) {
    if ((typeof css === "string" && node.matches(css)) || (css instanceof Node && node === css)) {
      return node;
    } else {
      node = node.parentElement;
    }
  }

  return null;
};
